export class AwsOpenSearchDomainRestoreTarget {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "domainName",
            "baseName": "domainName",
            "type": "string",
            "format": ""
        },
        {
            "name": "engineVersion",
            "baseName": "engineVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "instanceType",
            "baseName": "instanceType",
            "type": "string",
            "format": ""
        },
        {
            "name": "instanceCount",
            "baseName": "instanceCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "ebsVolumeSizeGb",
            "baseName": "ebsVolumeSizeGb",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "ebsVolumeType",
            "baseName": "ebsVolumeType",
            "type": "string",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsOpenSearchDomainRestoreTarget.attributeTypeMap;
    }
    constructor() {
    }
}
